import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// Reset Password token validation from the email link
const validateToken = async (token) => {

  let status = STATUSES.SUCCESS;
  /*{
    "resetPasswordToken":"",
  }*/
  let body = {
    "resetPasswordToken": token
  }

  const url = "/api/pwdToken/validateToken";
  const res = await http.post(url, body, {})
    .then((res) => {
      //console.log("validateToken() reset password", res);
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// reset password get MFA six digit code
const sendSmsFactor = async (token) => {

  let status = STATUSES.SUCCESS;

  const url = "/api/mfa/sendResetPwdUserSmsFactorToken/" + token;
  const res = await http.post(url, {}, {}).then((res) => {
    //console.log("sendSmsFactor()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the phone device
const submitMfa = async (resetPwdToken, mfaToken) => {

  let status = STATUSES.SUCCESS;

  let body = {
    "resetPwdToken": resetPwdToken,
    "mfaToken": mfaToken
  }

  const url = "/api/mfa/verifyResetPwdUserSmsFactorToken";
  const res = await http.post(url, body, {}).then((res) => {
    //console.log("submitMfa", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// Set up Mfa with the phone request
const setupMfa = async (token, request) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "resetPasswordToken": token,
    "mobileNumber": request.mobileNumber
  }

  const url = "/api/activation/setupMfa";
  const res = await http.post(url, body, {}).then((res) => {
    //console.log("setupMfa()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the new phone device
const submitMfaSetup = async (token, mfaToken) => {

  let status = STATUSES.SUCCESS;
  /*{
    "resetPasswordToken":token,
    "mfaToken":mfaToken
  }*/
  let body = {
    "resetPasswordToken": token,
    "mfaToken": mfaToken
  }

  const url = "/api/activation/setupMfaVerifyToken";
  const res = await http.post(url, body, {}).then((res) => {
    //console.log("submitMfa()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// auto ws pwd generator for reset password page
const getGeneratePWD = async () => {

  let status = STATUSES.SUCCESS;

  const url = "/api/activation/generatePwd";
  const res = await http.post(url, {}, {}).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getGeneratePWD()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// submit Reset Password
const submitResetPassword = async (token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  var request = {
    resetPasswordToken: token,
    newPwd: getFieldValue("newPassword", formInfo.data),
    confirmPwd: getFieldValue("conNewPassword", formInfo.data),
  }

  var url = "/api/pwdToken/resetPwd";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {}).then(res => {
    //console.log("submitResetPassword() axios", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// validate reset password for forgot password
const validateResetPassword = async (token, pwd) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "resetPasswordToken": token,
    "newPwd": pwd,
    "confirmPwd": pwd
  };

  const url = "/api/pwdToken/validatePwd";
  const res = await http.post(url, body, {}).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { validateToken, sendSmsFactor, submitMfa, setupMfa, submitMfaSetup, getGeneratePWD, submitResetPassword, validateResetPassword };